import { isNull } from 'lodash-es'

import { apiClient, Auth } from '@/shared/api'

import { RoomStatus } from '../model/room'
import { THostRoomProgress } from '../model/schema'

const DEFAULT_HOST_ROOM_PROGRESS = {
  stepCompletionStatus: {
    spaceInfo: false,
    feeInfo: false,
    options: false,
    description: false,
    contractPolicy: false,
  },
  requiredFieldsCompleted: false,
  roomStatus: RoomStatus.DRAFT,
}

export type HostRoomProgressParams = {
  roomId: number | null
}

export const getHostRoomProgress = async ({
  roomId,
}: HostRoomProgressParams) => {
  if (isNull(roomId) || isNaN(roomId)) {
    return DEFAULT_HOST_ROOM_PROGRESS
  }

  const { data } = await apiClient.get<THostRoomProgress>({
    endpoint: `/host/rooms/${roomId}/progress`,
    auth: Auth.REQUIRED,
  })

  return data
}
